import { useState } from "react";
import { Link } from "react-router-dom";
import { API_BASE } from "../api/apiConfig";

const Footer = () => {
      const [activeSheet, setActiveSheet] = useState(null);

  return (


    <>
      <div className='hidden sm:block'>
        <footer className="bg-slate-900 text-white">
          {/* Top Banner with Subscription */}
          <div className="bg-primary/10 border-b border-primary/20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
              <div className="text-center max-w-2xl mx-auto">
                <h3 className="text-2xl font-bold mb-4">Stay Connected with Our Travel Community</h3>
                <p className="mb-6">
                  Get the latest travel tips, community updates, and exclusive destination guides delivered to your inbox.
                </p>
                <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
                  <input
                    type="email"
                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 flex-1"
                    placeholder="Enter your email"
                    required
                  />
                  <button
                    className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-primary hover:bg-primary/90"
                    type="submit"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-send w-4 h-4 mr-2"
                    >
                      <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path>
                      <path d="m21.854 2.147-10.94 10.939"></path>
                    </svg>
                    Subscribe
                  </button>
                </form>
              </div>
            </div>
          </div>

          {/* Main Footer Content */}
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              
              {/* Community Logo & Description */}
              <div className="lg:col-span-1">
                <div className="flex items-center mb-6">
                   <img alt="Connecting Travelers" loading="lazy" decoding="async" src="/assets/images/logo1.png" className="mr-3" style={{ color: 'transparent' }} /> 
                  {/*<Link to="/" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                  <span className="text-xl font-bold text-primary">Connecting Travelers</span>
                  </Link>*/}
                </div>
                <p className="text-slate-300 mb-6 leading-relaxed">
                  Connecting travelers worldwide through authentic experiences, local expertise, and meaningful community connections.
                </p>
                {/* Social Icons */}
                <div className="flex space-x-4">
                  <a className="text-slate-400 hover:text-primary transition-colors" href="#">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-facebook w-5 h-5"
                    >
                      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                    </svg>
                  </a>
                  <a className="text-slate-400 hover:text-primary transition-colors" href="#">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-twitter w-5 h-5"
                    >
                      <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                    </svg>
                  </a>
                  <a className="text-slate-400 hover:text-primary transition-colors" href="#">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-instagram w-5 h-5"
                    >
                      <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line>
                    </svg>
                  </a>
                  <a className="text-slate-400 hover:text-primary transition-colors" href="#">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-youtube w-5 h-5"
                    >
                      <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"></path>
                      <path d="m10 15 5-3-5-3z"></path>
                    </svg>
                  </a>
                  <a className="text-slate-400 hover:text-primary transition-colors" href="#">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-linkedin w-5 h-5"
                    >
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                      <rect width="4" height="12" x="2" y="9"></rect>
                      <circle cx="4" cy="4" r="2"></circle>
                    </svg>
                  </a>
                </div>
              </div>
              
              {/* Explore Links */}
              <div>
                <h4 className="text-lg font-semibold text-primary mb-6 flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-compass w-5 h-5 mr-2"
                  >
                    <path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z"></path>
                    <circle cx="12" cy="12" r="10"></circle>
                  </svg>
                  Explore
                </h4>
                <ul className="space-y-3">
                  <li>
                    <Link to="/destinations" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                    <a className="text-slate-300 hover:text-primary transition-colors" href="#">
                      Destinations
                    </a>
                    </Link>
                  </li>
                  <li>
                    <Link to="/destinations" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                    <a className="text-slate-300 hover:text-primary transition-colors" href="destinations-dtl.html">
                      Travel Categories
                    </a>
                    </Link>
                  </li>
                  <li>
                    <Link to="/TravelTips" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                    <a className="text-slate-300 hover:text-primary transition-colors" href="travel-tips.html">
                      Travel Tips
                    </a>
                    </Link>
                  </li>
                  <li>
                    <Link to="/experts" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                    <a className="text-slate-300 hover:text-primary transition-colors" href="/experts">
                      Local Experts
                    </a>
                    </Link>
                  </li>
                  <li>
                    <Link to="/allexperts" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                    <a className="text-slate-300 hover:text-primary transition-colors" href="all-experts.html">
                      Browse All Experts
                    </a>
                    </Link>
                  </li>
                </ul>
              </div>
              
              {/* Community Links */}
              <div>
                <h4 className="text-lg font-semibold text-primary mb-6 flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-users w-5 h-5 mr-2"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                  Community
                </h4>
                <ul className="space-y-3">
                  <li>
                    <Link to="/community" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                    <a className="text-slate-300 hover:text-primary transition-colors" href="community">
                      Join Community
                    </a>
                    </Link>
                  </li>
                  <li>
                    <Link to="/meetups" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                    <a className="text-slate-300 hover:text-primary transition-colors" href="ExperienceTrips">
                      Experience Trips
                    </a>
                    </Link>
                  </li>
                  <li>
                    <Link to="/communitydtl" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                    <a className="text-slate-300 hover:text-primary transition-colors" href="CommunityCity">
                      City Communities
                    </a>
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                    <a className="text-slate-300 hover:text-primary transition-colors" href="about">
                      About Us
                    </a>
                    </Link>
                  </li>
                  <li>
                    <Link to="/login" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                    <a className="text-slate-300 hover:text-primary transition-colors" href="auth1.html">
                      Sign Up
                    </a>
                    </Link>
                  </li>
                </ul>
              </div>
              
              {/* Contact & Support */}
              <div>
                <h4 className="text-lg font-semibold text-primary mb-6 flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-globe w-5 h-5 mr-2"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                    <path d="M2 12h20"></path>
                  </svg>
                  Contact &amp; Support
                </h4>
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-mail w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0"
                    >
                      <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                    </svg>
                    <div>
                      <p className="text-slate-300">info@connectingtraveller.com</p>
                      <p className="text-slate-400 text-sm">General inquiries</p>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-phone w-5 h-5 text-primary mr-3 mt-0.5"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    <div>
                      <p className="text-slate-300">+91 8920866123</p>
                      <p className="text-slate-400 text-sm">24/7 Support</p>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin w-5 h-5 text-primary mr-3 mt-0.5"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <div>
                      <p className="text-slate-300">Delhi,India</p>
                      <p className="text-slate-400 text-sm">Headquarters</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            
            {/* Stats Section */}
            <div className="border-t border-slate-700 mt-12 pt-8">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
                <div>
                  <div className="text-2xl font-bold text-primary mb-1">50K+</div>
                  <div className="text-slate-400 text-sm">Active Travelers</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-primary mb-1">200+</div>
                  <div className="text-slate-400 text-sm">Destinations</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-primary mb-1">1K+</div>
                  <div className="text-slate-400 text-sm">Local Experts</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-primary mb-1">25K+</div>
                  <div className="text-slate-400 text-sm">Meetups Hosted</div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Footer Bar */}
          <div className="border-t border-slate-700">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
              <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                {/* Left: Copyright */}
                <div className="flex items-center text-slate-400 text-sm">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-heart w-4 h-4 text-primary mr-2"
                  >
                    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                  </svg>
                  <span>© 2026 Connecting Travelers. Made with love for travelers worldwide.</span>
                </div>
                {/* Right: Links */}
                <div className="flex flex-wrap justify-center md:justify-end space-x-6 text-sm">
                  <Link to="/PrivacyPolicy" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                  <a className="text-slate-400 hover:text-primary transition-colors" href="/PrivacyPolicy">
                    Privacy Policy
                  </a>
                  </Link>
               
                  <Link to="/TermsOfservice" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                  <a className="text-slate-400 hover:text-primary transition-colors" href="/TermsOfservice">
                    Terms of Service
                  </a>
                  </Link>
                  <Link to="/CookiePolicy" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                  <a className="text-slate-400 hover:text-primary transition-colors" href="/CookiePolicy">
                    Cookie Policy
                  </a>
                  </Link>
                  <Link to="/Help" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                  <a className="text-slate-400 hover:text-primary transition-colors" href="/Help">
                    Help Center
                  </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>

        

        </footer>
      </div>

      <div className='block sm:hidden'>
        <div className='mobile-app-container'>
          <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-slate-200 shadow-lg">
            <div className="flex items-center justify-around h-16">
              
              <Link to="/" className="flex flex-col items-center justify-center w-full h-full text-primary" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
              <a
                href="#"
                className="flex flex-col items-center justify-center w-full h-full text-primary"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-home h-5 w-5"
                >
                  <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                  <polyline points="9 22 9 12 15 12 15 22" />
                </svg>
                <span className="text-xs mt-1">Home</span>
              </a>
              </Link>
             
             
               <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveSheet("explore");
                }}
                className="flex flex-col items-center justify-center w-full h-14 text-slate-500"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map h-5 w-5"><polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"></polygon><line x1="9" x2="9" y1="3" y2="18"></line><line x1="15" x2="15" y1="6" y2="21"></line></svg>
                <span className="text-xs mt-1">Trips</span>
              </a>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveSheet("expert");
                }}
                className="flex flex-col items-center justify-center w-full h-full text-slate-500"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users h-5 w-5"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                <span className="text-xs mt-1">Community</span>
              </a>
              <a
                href="https://wa.me/918920866123" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center justify-center w-full h-full text-green-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-message-circle h-5 w-5"
                >
                  <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" />
                </svg>
                <span className="text-xs mt-1">Chat</span>
              </a>

            </div>
          </nav>
        </div>

     

         {/* ===== Overlay ===== */}
          {activeSheet && (
            <div
              onClick={() => setActiveSheet(null)}
              className="fixed inset-0 bg-black/40 z-40"
            />
          )}

          {/* ===== Explore Div ===== */}
          <div
            className={`fixed bottom-0 left-0 right-0 z-50 bg-white rounded-t-3xl shadow-2xl transform transition-transform duration-300
            ${activeSheet === "explore" ? "translate-y-0" : "translate-y-full"}`}
          >
            <div className="p-6">
                <div className="flex justify-between items-center mb-6">
                  <h3 className="text-lg font-semibold text-slate-800">Explore Trips</h3>
                  <button className="p-2 hover:bg-slate-100 rounded-full transition-colors" onClick={() => setActiveSheet(null)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-x h-5 w-5 text-slate-600"
                    >
                      <path d="M18 6 6 18" />
                      <path d="m6 6 12 12" />
                    </svg>
                  </button>
                </div>
                <div className="space-y-3">
                   <Link to="/grouptrips" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                  <a
                    className="flex items-center gap-4 p-4 bg-gradient-to-r from-teal-50 to-cyan-50 rounded-xl hover:shadow-md transition-all"
                    href="#"
                  >
                    <div className="flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden">
                      <img
                        alt="Group Trips"
                        loading="lazy"
                        width={64}
                        height={64}
                        decoding="async"
                        data-nimg={1}
                        className="object-cover"
                        style={{ color: "transparent" }}
                        src="/assets/images/group-of-happy-travelers.jpg"
                      />
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-slate-800 mb-1">Group Trips</h4>
                      <p className="text-xs text-slate-600">
                        Join curated group adventures
                      </p>
                    </div>
                  </a>
                  </Link>
                  <Link to="/customizedtrips" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                  <a
                    className="flex items-center gap-4 p-4 bg-gradient-to-r from-orange-50 to-amber-50 rounded-xl hover:shadow-md transition-all mt-4"
                    href="/customized-trips"
                  >
                    <div className="flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden">
                      <img
                        alt="Customized Trips"
                        loading="lazy"
                        width={64}
                        height={64}
                        decoding="async"
                        data-nimg={1}
                        className="object-cover"
                        style={{ color: "transparent" }}
                        src="/assets/images/customized-travel-planning.jpg"
                      />
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-slate-800 mb-1">Customized Trips</h4>
                      <p className="text-xs text-slate-600">Plan your perfect journey</p>
                    </div>
                  </a>
                  </Link>
                </div>
              </div>
          </div>

          {/* ===== Expert Div ===== */}
          <div
            className={`fixed bottom-0 left-0 right-0 z-50 bg-white rounded-t-3xl shadow-2xl transform transition-transform duration-300
            ${activeSheet === "expert" ? "translate-y-0" : "translate-y-full"}`}
          >
            <div className="p-6">
                <div className="flex justify-between items-center mb-6">
                  <h3 className="text-lg font-semibold text-slate-800">Join Community</h3>
                  <button className="p-2 hover:bg-slate-100 rounded-full transition-colors" onClick={() => setActiveSheet(null)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-x h-5 w-5 text-slate-600"
                    >
                      <path d="M18 6 6 18" />
                      <path d="m6 6 12 12" />
                    </svg>
                  </button>
                </div>
                <div className="space-y-3">
                  <Link to="/community" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                  <a
                    className="flex items-center gap-4 p-4 bg-gradient-to-r from-purple-50 to-indigo-50 rounded-xl hover:shadow-md transition-all"
                    href="/community"
                  >
                    <div className="flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden bg-gradient-to-br from-purple-500 to-indigo-500 flex items-center justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-users h-8 w-8 text-white"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx={9} cy={7} r={4} />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-slate-800 mb-1">Explore Community</h4>
                      <p className="text-xs text-slate-600">
                        Connect with travelers in your city
                      </p>
                    </div>
                  </a>
                  </Link>

                  <Link to="/experiencetrips" onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }>
                  <a
                    className="flex items-center gap-4 p-4 bg-gradient-to-r from-pink-50 to-rose-50 rounded-xl hover:shadow-md transition-all mt-4"
                    href="/experiencetrips"
                  >
                    <div className="flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden bg-gradient-to-br from-pink-500 to-rose-500 flex items-center justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-users h-8 w-8 text-white"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx={9} cy={7} r={4} />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-slate-800 mb-1">Experience Trips</h4>
                      <p className="text-xs text-slate-600">
                        Curated adventures by Travel Experts
                      </p>
                    </div>
                  </a>
                  </Link>
                </div>
              </div>

           
          </div>

      </div>
    </>
  




  );
};

export default Footer;



